<script lang="ts">
  import { createWhatsappSupportUrl } from "../../constants/url";
  import { t } from "../../helpers/translations";
  import TextNew from "../TextNew.svelte";
  import ModalInstructionsStepCard from "../modals/ModalInstructionsStepCard.svelte";

  export let description: string;
  const SUPPORT_URL = createWhatsappSupportUrl();
</script>

<ModalInstructionsStepCard variant="link" url={SUPPORT_URL} title={t("salesModal.help.title")}>
  <TextNew size="s" --rk-text-color="var(--rk-text-low)" --line-height="24px">
    {description}
  </TextNew>
</ModalInstructionsStepCard>
